import { apiBaseURL } from "../ProjectConstants";

export async function handlePostPOComments(
  poOrderId,
  comment,
  userId,
  today,
  fetch,
) {
  const body = {
    orderId: poOrderId,
    comment: comment,
    userId: userId,
    date: today,
  };
  console.log(" before handlePostPOComments =>", body);

  //   const response = null;
  const response = await fetch.post(
    `${apiBaseURL}/api/PurchaseOrder/Comments`,
    body,
  );
  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== "Invalid Model";

  console.log("handlePostPOComments body", body, response);

  return {
    response,
    isDataGood,
  };
}
